export default function SvgIcon({
  name,
  prefix = "icon",
  color = "#333",
  ...props
}: React.SVGProps<SVGSVGElement> & { name: string; prefix?: string; color?: string }) {
  const symbolId = `#${prefix}-${name}`;

  return (
    <svg {...props} aria-hidden="true">
      <use href={symbolId} fill={color} />
    </svg>
  );
}
